import { render } from "./SharedMatterTags.vue?vue&type=template&id=4a34849f"
import script from "./SharedMatterTags.vue?vue&type=script&lang=js"
export * from "./SharedMatterTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__